import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

var config = {
  apiKey: 'AIzaSyA1_oan68m5Tt5_M-QShIPlWVUrQEPS9wE',
  authDomain: 'muraija-auth.firebaseapp.com',
  databaseURL: 'https://muraija-auth.firebaseio.com',
  projectId: 'muraija-auth',
  storageBucket: 'muraija-auth.appspot.com',
  messagingSenderId: '753619897583'
}

export const app = initializeApp(config)
export const auth = getAuth(app)

export function getFirebaseUsersInLocalStorage () {
  const keys = Object.keys(localStorage).filter(key => key.startsWith('firebase:authUser'))
  return keys.map(key => JSON.parse(localStorage.getItem(key)))
}